import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-triangle",
  "use": "arrow-triangle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-triangle\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 6.41421C8 5.52331 9.07714 5.07714 9.70711 5.70711L15.2929 11.2929C15.6834 11.6834 15.6834 12.3166 15.2929 12.7071L9.7071 18.2929C9.07714 18.9229 8 18.4767 8 17.5858L8 6.41421Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol